function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 12.4376V6.13333C32 4.95513 31.0449 4 29.8667 4H0V28.3333H29.8667C31.0449 28.3333 32 27.3782 32 26.2V19.8291C30.7247 19.0913 29.8667 17.7126 29.8667 16.1333C29.8667 14.5541 30.7247 13.1754 32 12.4376Z",
  fill: "url(#paint0_radial_2509_4759)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.94141 11.704V20.272H6.82541V11.704H4.94141Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3645 18.688V13.288H11.7085C12.1725 13.288 12.5605 13.356 12.8725 13.492C13.1925 13.62 13.4485 13.808 13.6405 14.056C13.8325 14.304 13.9685 14.604 14.0485 14.956C14.1365 15.3 14.1805 15.688 14.1805 16.12C14.1805 16.592 14.1205 16.992 14.0005 17.32C13.8805 17.648 13.7205 17.916 13.5205 18.124C13.3205 18.324 13.0925 18.468 12.8365 18.556C12.5805 18.644 12.3165 18.688 12.0445 18.688H10.3645ZM8.48047 11.704V20.272H12.1765C12.8325 20.272 13.4005 20.164 13.8805 19.948C14.3685 19.724 14.7725 19.42 15.0925 19.036C15.4205 18.652 15.6645 18.196 15.8245 17.668C15.9845 17.14 16.0645 16.564 16.0645 15.94C16.0645 15.228 15.9645 14.608 15.7645 14.08C15.5725 13.552 15.3005 13.112 14.9485 12.76C14.6045 12.408 14.1925 12.144 13.7125 11.968C13.2405 11.792 12.7285 11.704 12.1765 11.704H8.48047Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.887 16.024C18.887 15.648 18.927 15.284 19.007 14.932C19.095 14.58 19.231 14.268 19.415 13.996C19.599 13.716 19.839 13.496 20.135 13.336C20.431 13.168 20.791 13.084 21.215 13.084C21.639 13.084 21.999 13.168 22.295 13.336C22.591 13.496 22.831 13.716 23.015 13.996C23.199 14.268 23.331 14.58 23.411 14.932C23.499 15.284 23.543 15.648 23.543 16.024C23.543 16.384 23.499 16.736 23.411 17.08C23.331 17.416 23.199 17.72 23.015 17.992C22.831 18.264 22.591 18.484 22.295 18.652C21.999 18.812 21.639 18.892 21.215 18.892C20.791 18.892 20.431 18.812 20.135 18.652C19.839 18.484 19.599 18.264 19.415 17.992C19.231 17.72 19.095 17.416 19.007 17.08C18.927 16.736 18.887 16.384 18.887 16.024ZM17.003 16.024C17.003 16.648 17.099 17.232 17.291 17.776C17.483 18.312 17.759 18.78 18.119 19.18C18.479 19.58 18.919 19.896 19.439 20.128C19.967 20.352 20.559 20.464 21.215 20.464C21.879 20.464 22.471 20.352 22.991 20.128C23.511 19.896 23.951 19.58 24.311 19.18C24.671 18.78 24.947 18.312 25.139 17.776C25.331 17.232 25.427 16.648 25.427 16.024C25.427 15.384 25.331 14.792 25.139 14.248C24.947 13.696 24.671 13.216 24.311 12.808C23.951 12.4 23.511 12.08 22.991 11.848C22.471 11.616 21.879 11.5 21.215 11.5C20.559 11.5 19.967 11.616 19.439 11.848C18.919 12.08 18.479 12.4 18.119 12.808C17.759 13.216 17.483 13.696 17.291 14.248C17.099 14.792 17.003 15.384 17.003 16.024Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_2509_4759",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(34.8213 28.3848) scale(47.1106 35.8196)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})));

function SvgIdoLotteryTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdoLotteryTicket);
export default __webpack_public_path__ + "static/media/idoLotteryTicket.d2bdae98395806592e05492178941d35.svg";
export { ForwardRef as ReactComponent };